import React from "react";

import { RegistrationNumberCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function registrationNumber({ width, onResize }: Column.Options) {
	return base(
		ColumnId.RegistrationNumber,
		(item) => <Content item={item} />,
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default registrationNumber;
